import * as React from 'react';
import { FieldErrorMessage } from '../../Validation/FieldErrorMessage';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * Helper component to standardise the display of error messages when using Formik.
 * Formik control wrappers in this library have this capability built in.
 * Other controls should use this component and wire up the properties as documented in props.
 * Outside of Formik use the FieldErrorMessage component to display associated error messages.
 * @param {FormikErrorMessageProps} props
 * @returns Error message text, when the input has an asociated error message and it has been touched.
 */
export const FormikErrorMessage = props => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: props.errorMessage && props.touched && /*#__PURE__*/_jsx(FieldErrorMessage, {
      children: props.errorMessage
    })
  });
};